import FastClick from './vendor/fastclick';
import Menu from './menu';
import ProductArchive from './product-archive';
require("./vendor/modernizr-custom");
require("./vendor/isInViewport.min");
require("./vendor/owl.carousel.min");
require("./vendor/jquery.counterup");
require("./vendor/jquery.waypoints.min");
require("./vendor/imagesloaded");
let returnFocusTo = null;

jQuery(document).ready(function ($) {
    // Global variables
    let breakpoint = $('html').css('zIndex');

    // Fastclick
    FastClick.attach(document.body);

    // Resize end trigger
    $(window).resize(function () {
        if (this.resizeTO) clearTimeout(this.resizeTO);
        this.resizeTO = setTimeout(function () {
            $(this).trigger('resizeEnd');
        }, 500);
    });

    // After resize
    $(window).bind('resizeEnd', function () {
        breakpoint = $('html').css('zIndex');
    });

    // Run on load
    oc_menu();
    oc_smooth();
    oc_carousels();
    oc_counters();
    oc_videos();
    oc_search();

    // Wait for images to load
    $('body').imagesLoaded(function () {
        oc_waypoints();
    });

    function oc_menu() {
        // Menu button trigger
        $('#menu-button').click(function (e) {
            e.preventDefault();
            $('body').toggleClass('menu-active');
        });
    }

    function oc_smooth() {
        $('a[href*="#"]:not([href="#"])').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });

        // If hash, scroll to anchor with offset
        var hash = window.location.hash
        if (hash == '' || hash == '#' || hash == undefined) return false;
        var target = $(hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top
            }, 500);
            return false;
        }
    }

    function oc_carousels() {
        $('.hero-carousel .owl-carousel').owlCarousel({
            items: 1,
            dots: true,
            nav: true,
            mouseDrag: false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            loop: true
        });
    }

    function oc_waypoints() {
        // Autoplay map video on scroll
        $('.map__video').waypoint(function (direction) {
            if (direction == 'down') {
                this.element.play();
                this.destroy();
            }
        }, {
            offset: '70%'
        });
    }

    function oc_counters() {
        $('.counter').counterUp({
            time: 2000
        });
    }

    function oc_videos() {
        $('.video-wrap__overlay').click(function (e) {
            e.preventDefault();
            let $iframe = $(this).next('iframe'),
                src = $iframe.attr('src');
            $iframe.attr('src', src + '&autoplay=1');
            $(this).fadeOut();
        });
    }

    function oc_search() {
        $('#search-button').click(function (e) {
            e.preventDefault();
            if ($('body').hasClass('search-active')) {
                $('header .searchform').submit();
            }
            else {
                $('body').addClass('search-active');
                let val = $('header .searchform input[type="text"]').val();
                $('header .searchform input[type="text"]').focus().val('').val(val);
            }
        });
        $('header .searchform input[type="text"]').blur(function (e) {
            if (!$(e.relatedTarget).is('#search-button')) {
                $('body').removeClass('search-active');
            }
        });
    }

    const menus = document.querySelectorAll(".menu-toggle");
    menus.forEach(el => {
        new Menu(el);
    });

    const productArchive = document.querySelector('.products__list');
    if (productArchive) {
        new ProductArchive(productArchive);
    }

});
